import React, { useState, useEffect } from "react";

import {
  Typography,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Grid,
  Card,
  CardContent,
  CardActionArea,
} from "@material-ui/core";
import { HourglassEmpty, OpenInBrowser } from "@material-ui/icons/";

import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { getAcceptedOrders } from "../../../actions/sellerActions";

// import moment from "moment";

import Loading from "../../Loading";
// import Countdown from "./Countdown";

const AcceptedOrders = (props) => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);

  useEffect(() => {
    if (props.auth.isAuthenticated) {
      props.getAcceptedOrders(props.auth.seller._id);
    }
  }, [props.auth.isAuthenticated]);

  useEffect(() => {
    if (props.acceptedOrders) {
      setData(props.acceptedOrders);
      setLoading(false);
    }
  }, [props.acceptedOrders]);

  // function calculateCountDownTime(acceptTime, preparationTime) {
  //   const currentTime = new Date().toLocaleTimeString();
  //   const ATime = acceptTime;
  //   var cTime = moment(currentTime, "HH:mm:ss a");
  //   var aTime = moment(ATime, "HH:mm:ss a");
  //   var duration = moment.duration(cTime.diff(aTime));
  //   const pTime = preparationTime.split(",");
  //   const CountdownTimeHours = pTime[1] - parseInt(duration.as("hours"));
  //   const CountdownTimeMinutes = pTime[0] - parseInt(duration.as("minutes"));
  //   if (CountdownTimeHours < 0 && CountdownTimeMinutes < 0) {
  //     return null;
  //   } else {
  //     return `${CountdownTimeHours}:${CountdownTimeMinutes}`;
  //   }
  // }

  if (loading) {
    return (
      <div>
        <Loading />
      </div>
    );
  }

  return (
    <div>
      <div
        style={{
          backgroundColor: "maroon",
          color: "white",
          padding: "1px 0 1px 30px",
          margin: "10px 0",
          borderRadius: "10px",
        }}
      >
        <div style={{ display: "flex",alignItems:'center' }}>
          <OpenInBrowser
            style={{
              height: 35,
              width: 35,
              marginRight: 10,
            }}
          />
          <h3>Orders To Pack</h3>
        </div>
      </div>
      {!loading && (data.length === 0 || !data) ? (
        <div style={{ display: "flex" }}>
          <HourglassEmpty style={{ margin: "20px 20px 20px 0" }} />
          <h3>No Order To Prepare</h3>
        </div>
      ) : (
        <Grid container spacing={2}>
          {data.map((Order, index) => {
            const { buyer, order, location, address, _id, preparationTime } =
              Order;

            return (
              <Grid item xs={12} md={6} lg={4}>
                <Card
                  variant="outlined"
                  style={{ padding: "10px 0", backgroundColor: "bisque" }}
                >
                  <CardActionArea>
                    <Link
                      to={`/order/assignment/${_id}`}
                      style={{ textDecoration: "none" }}
                    >
                      <CardContent>
                        <>
                          <div style={{ display: "inline-flex", width: "90%" }}>
                            <Typography
                              variant="h6"
                              style={{ marginLeft: "15px", color: "black" }}
                            >
                              {buyer.name}
                            </Typography>
                            {/* <div style={{ marginLeft: "auto" }}>
                              {preparationTime.days === 0 &&
                                (preparationTime.mins !== 0 ||
                                  preparationTime.hours !== 0) && (
                                  <Countdown
                                    preparationTime={preparationTime}
                                  />
                                )}
                            </div> */}
                          </div>
                          <div>
                            <Table className="table">
                              <TableHead>
                                <TableRow>
                                  <TableCell></TableCell>
                                  <TableCell className="bigDevices">
                                    <b>Items</b>
                                  </TableCell>
                                  <TableCell numeric>
                                    <b>Quantity</b>
                                  </TableCell>
                                </TableRow>
                              </TableHead>
                              {order.map((arder) => {
                                const { item, quantity } = arder;
                                return (
                                  <TableBody>
                                    <TableRow>
                                      <TableCell>
                                        <img
                                          src={item.images[0]}
                                          style={{
                                            width: "75px",
                                            borderRadius: "13%",
                                          }}
                                          alt="ItemImage"
                                        />
                                      </TableCell>
                                      <TableCell
                                        component="th"
                                        scope="row"
                                        className="bigDevices"
                                      >
                                        {item.name}
                                      </TableCell>
                                      <TableCell numeric>{quantity}</TableCell>
                                    </TableRow>
                                  </TableBody>
                                );
                              })}
                            </Table>
                          </div>
                        </>
                      </CardContent>
                      <div style={{ textAlign: "center",color:'black' }}>
                        <p>
                          Address: <b>{address}</b>
                        </p>
                      </div>
                    </Link>
                  </CardActionArea>
                </Card>
              </Grid>
            );
          })}
        </Grid>
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  acceptedOrders: state.server.acceptedOrders,
});
export default connect(mapStateToProps, { getAcceptedOrders })(AcceptedOrders);
